export default __webpack_public_path__ + "8e134dda7978e06e3050ca2ab40dad7c.png";